import styled from '@emotion/styled'

const Label = styled.label`
  display: block;
  padding-top: 16px;
`

export default Label



// WEBPACK FOOTER //
// ./src/routes/admin/Label.js